export default __webpack_public_path__ + "static/media/esnad.07e9e376.svg";